<template>
    <div>
        <h5>All Existing Blocks</h5>
        <div class="card">
            <Button label="Create a block" @click="createBlock" />
        </div>
        <block-table :isGodUser="isGodUser" :userCompanyId="userCompanyId.id" :reloadTable="reloadTable" @reload-table="reloadTable = !reloadTable" />
    </div>
</template>

<script>
import BlockTable from './BlockTable.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'Blocks',
    components: { BlockTable },
    data() {
        return {
            addBlockDialog: false,
            reloadTable: false,
        };
    },
    computed: {
        ...mapGetters('auth', ['userCompanyId', 'isGodUser']),
    },
    methods: {
        createBlock() {
            this.$router.push('/blocks/addBlock');
        },
    },
};
</script>
